<script setup lang="ts">
withDefaults(
  defineProps<{
    centered?: boolean
    description?: string
    icon?: string
    title: string
    variant?: "panel" | "compact"
  }>(),
  {
    centered: true,
    description: "",
    icon: "i-ph-database",
    variant: "panel"
  }
)
</script>

<template>
  <div
    class="dashboard-empty-state"
    :class="[
      centered ? 'dashboard-empty-state--center' : 'dashboard-empty-state--start',
      variant === 'compact' ? 'dashboard-empty-state--compact' : ''
    ]"
  >
    <UIcon v-if="icon" :name="icon" class="dashboard-empty-state__icon" />
    <div class="dashboard-empty-state__copy">
      <p class="dashboard-empty-state__title">{{ title }}</p>
      <p v-if="description" class="dashboard-empty-state__description">{{ description }}</p>
      <slot />
    </div>
  </div>
</template>
